import { Call } from '@twilio/voice-sdk';
import TwilioCall from '../../twilio-call/TwilioCall';

interface Props {
  toName: string;
  toNumber: string;
  onCloseCb: () => void;
  locationTenantId?: string;
  locationId?: number;
  onCallInitiated?: (call: Call) => void;
  onCallDisconnected?: (call: Call) => void;
}

export function DraggableCallView(props: Props) {
  const {
    toName,
    toNumber,
    onCloseCb,
    locationTenantId,
    locationId,
    onCallInitiated,
    onCallDisconnected,
  } = props;

  return (
    <TwilioCall
      toName={toName}
      toNumber={toNumber}
      onCloseCb={onCloseCb}
      onCallInitiated={onCallInitiated}
      onCallDisconnected={onCallDisconnected}
      locationTenantId={locationTenantId}
      locationId={locationId}
    />
  );
}

export default DraggableCallView;
